import React, { Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

type Props = {
  children: ReactNode,
}

const TriggerActionDialogBody = ({
  children,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Fragment>
      {children}
      <br />
      <br />
      {t('accessFunction.actionPopup.note')}
    </Fragment>
  );
};

export default TriggerActionDialogBody;
